import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const location = useLocation();

  if (userInfo) {
    return <Outlet />;
  }

  const redirect = `${location.pathname}${location.search}`;
  const searchParams = new URLSearchParams();
  if (redirect && redirect !== '/') {
    searchParams.set('redirect', redirect);
  }

  return <Navigate to={`/login${searchParams.toString() ? `?${searchParams.toString()}` : ''}`} replace />;
};
export default PrivateRoute;
